import { useState, useEffect } from "react";
import { api } from "@/lib/appresse";

// Programme ambassadeur masqué pour tout le monde (remettre à true pour le réafficher).
export const AMBASSADOR_VISIBLE = false;

// Fetches the ambassador challenge config once and ticks every second.
export function useChallenge() {
  const [data, setData] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let mounted = true;
    api.challenge().then((d) => { if (mounted) setData(d); }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);

  if (!data) return { loading: true };
  const end = new Date(data.end_date).getTime();
  const total = Math.max(0, end - now);
  const ended = data.ended || total <= 0;
  const s = Math.floor(total / 1000);
  const parts = {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
  return {
    loading: false,
    enabled: !!data.enabled,
    active: !!data.enabled && !ended,
    ended,
    hasShared: !!data.has_shared,
    endDate: data.end_date,
    parts,
    total,
  };
}

const pad = (n) => String(n).padStart(2, "0");

// "30j 12:04:50"
export function fmtCountdown(p) {
  return `${p.d}j ${pad(p.h)}:${pad(p.m)}:${pad(p.s)}`;
}

// "J-30" style compact for tight spaces
export function fmtCompact(p) {
  if (p.d > 0) return `J-${p.d}`;
  return `${pad(p.h)}:${pad(p.m)}:${pad(p.s)}`;
}
